// Synthetic AI-assisted recommendations used for the primary governed action flow.
// These are NOT live AI calls. They illustrate the suggestion → review → signed-receipt
// shape that AICierge governs. Evidence stays with originating systems; only minimal
// references are shared.

export const GOVERNED_RECOMMENDATIONS = [
  {
    id: "rec_reroute_zone_b",
    title: "Re-route 12 outstanding care visits in Zone B",
    summary:
      "An AI routing layer evaluated the local road network, surface-water modelling and the care-visit schedule, and proposes a northern-corridor alternative.",
    action_class: "operational_recommendation.reroute",
    authority_gate: "operations.recommendation.review",
    suggested_outcome: "approved",
    actor: { role: "Duty Manager", ref: "role:duty-manager" },
    custody: {
      shared_evidence: [
        { ref: "ev:road-network-state-v3", note: "Reference only — full graph not transferred" },
        { ref: "ev:surface-water-forecast-72h", note: "Aggregate severity bands" },
        { ref: "ev:care-visit-priority-bands", note: "No resident identifiers — banded counts only" },
      ],
      withheld_evidence: [
        { reason: "Personal address-level resident data" },
        { reason: "Carer roster identifiers" },
      ],
    },
    boundary_note:
      "Resident identities, addresses and carer rosters remain in the originating care system. Only banded counts and forecast references are shared.",
  },
  {
    id: "rec_publish_status",
    title: "Publish a 280-character public service update",
    summary:
      "An AI drafting model produced a candidate public status post summarising current bus diversions, scheduled for the council channel.",
    action_class: "communication.public_status",
    authority_gate: "communications.public_post.acknowledge",
    suggested_outcome: "approved",
    actor: { role: "Communications Lead", ref: "role:comms-lead" },
    custody: {
      shared_evidence: [
        { ref: "ev:bus-diversions-list-current", note: "Operational reference, public-safe" },
        { ref: "ev:council-channel-style-guide-v2", note: "Style reference only" },
      ],
      withheld_evidence: [],
    },
    boundary_note:
      "Public post — no personal data involved. Style and operational refs are shared; the post text itself is reviewed by the Communications Lead before sign-off.",
  },
  {
    id: "rec_share_with_partner",
    title: "Share at-risk-resident shortlist with a neighbouring authority",
    summary:
      "An AI summarisation model produced a shortlist of ground-floor properties with mobility flags for joint flood response with a neighbouring public-sector stakeholder.",
    action_class: "disclosure.external_partner",
    authority_gate: "disclosure.cross_boundary.multi_party_review",
    suggested_outcome: "refused",
    actor: { role: "Duty Manager", ref: "role:duty-manager" },
    custody: {
      shared_evidence: [
        { ref: "ev:partner-mutual-aid-agreement-v4", note: "Agreement reference" },
      ],
      withheld_evidence: [
        { reason: "Resident-level mobility flags" },
        { reason: "Ground-floor address list" },
        { reason: "Carer-of-record identifiers" },
      ],
    },
    boundary_note:
      "Sensitive cross-boundary action. By default, resident identifiers, addresses and mobility flags are withheld. KATLAS records the refusal — the public-sector stakeholder receives banded counts only.",
  },
];
